import React from 'react';
import { View, StyleSheet, Text } from 'react-native';
import CS from '../constants/Styles';

export default function ULItem({ ...props }) {
  const textColor = () => {
    if(props.textColor){
      if (CS[props.textColor + 'Text']){
        return CS[props.textColor + 'Text'];
      }
    }
    return CS.lightText;
  };

  return (
    <View style={[CS.rowContainer, styles.listItem]}>
      <Text style={[CS.smallText, textColor(), styles.bullet]}>{'\u2022'}</Text>
      <Text style={[CS.smallText, textColor()]}>{props.text}</Text>
    </View>
  );
}

const styles = StyleSheet.create({
  listItem: {
    marginBottom:5,
    alignItems: 'flex-start',
  },
  bullet: {
    marginRight: 7,
  }
})
